import React, { useEffect, createElement } from 'react';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
function loadWistiaScripts() {
  if (!document.querySelector('script[src="https://fast.wistia.com/player.js"]')) {
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
  }
  if (!document.querySelector('script[src="https://fast.wistia.com/embed/e2y4ndfygi.js"]')) {
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/e2y4ndfygi.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
  }
}
export function HeroSection() {
  useEffect(() => {
    loadWistiaScripts();
  }, []);
  return <section className="bg-dark py-28 md:py-32 px-4" data-id="element-83">
      <div className="max-w-[1100px] mx-auto flex flex-col items-center text-center" data-id="element-84">
        <span className="text-accent font-bold tracking-widest text-sm uppercase mb-6" data-id="element-85">
          PARA QUIEN YA VIO SUS FUGAS EN EL MAPA
        </span>

        <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold text-textLight mb-8 leading-tight" data-id="element-86">
          Trabajas mucho. Creces poco. Tienes fugas.
        </h1>

        <p className="text-lg md:text-xl text-textLight mb-12 max-w-3xl leading-relaxed" data-id="element-87">
          En 90 minutos vas a identificar las fugas de tiempo, energía y foco
          que están drenando tu negocio — y vas a salir sabiendo cuál es tu 20%
          medular para crecer sin tener que correr más.
        </p>

        <div className="flex flex-col items-start text-left gap-5 mb-16 w-full max-w-2xl mx-auto" data-id="element-88">
          <div className="flex items-start gap-4" data-id="element-89">
            <Check className="text-accentSecondary shrink-0 mt-1" size={24} data-id="element-90" />
            <span className="text-lg text-textLight font-medium" data-id="element-91">
              Descubre las fugas invisibles que llevan años drenando tus
              ingresos.
            </span>
          </div>
          <div className="flex items-start gap-4" data-id="element-92">
            <Check className="text-accentSecondary shrink-0 mt-1" size={24} data-id="element-93" />
            <span className="text-lg text-textLight font-medium" data-id="element-94">
              Identifica qué actividades te mantienen ocupada sin hacerte
              crecer.
            </span>
          </div>
          <div className="flex items-start gap-4" data-id="element-95">
            <Check className="text-accentSecondary shrink-0 mt-1" size={24} data-id="element-96" />
            <span className="text-lg text-textLight font-medium" data-id="element-97">
              Sal con un criterio claro para priorizar tu 20% y soltar el resto.
            </span>
          </div>
        </div>

        <div className="mb-16 rounded-xl overflow-hidden shadow-2xl w-full" style={{
        maxWidth: '800px',
        margin: '0 auto 4rem auto'
      }} data-id="element-98">
          <style data-id="element-99">{`
            wistia-player[media-id='e2y4ndfygi']:not(:defined) {
              background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/e2y4ndfygi/swatch');
              display: block;
              filter: blur(5px);
              padding-top: 177.78%;
            }
          `}</style>
          {/* @ts-ignore */}
          <wistia-player media-id="e2y4ndfygi" aspect="0.5625" style={{
          width: '100%'
        }} data-id="element-100"></wistia-player>
        </div>

        <CTAButton className="mb-6 w-full md:w-auto" data-id="element-101">
          QUIERO MI ENTRADA A JDON
        </CTAButton>

        <p className="text-sm text-textSecondary mt-4 max-w-2xl mx-auto leading-relaxed" data-id="element-102">
          +20 años en ventas reales. Vicepresidenta regional en multinacional.
          Fundadora de 2 empresas. 260 personas acompañadas en 7 países desde
          noviembre de 2025. Esto no es motivación. Es criterio.
        </p>
      </div>
    </section>;
}